import React, { Component } from 'react'
import { EndCallChangePwdTheme } from 'modules/theme'

export class EndCallChangePwd extends Component {
  render() {
    return (
      <EndCallChangePwdTheme
        onDoneClick={''}
        ButtonText={'Done'}
      />
    )
  }
}

export default EndCallChangePwd


// WEBPACK FOOTER //
// src/dialpad/components/layout/EndCallChangePwd.js